module.exports = __webpack_public_path__ + "img/cholesterol_meter_grey.df0293e8.svg";